import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "../../styles/CCInstantPay.css";
import "../../styles/CommonBbps.css";
import Call_Api from "../../Common/Handileapi/Call_api";
import { setDetailsToSend } from "../../redux/slice/detailsToSendSlice";
import { path } from "../../routes/Paths";
import Cookies from "js-cookie";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";

const CCInstantPay = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const doubleTap = useRef(false);
  const token = Cookies.get("token");

  const detailsToSend = useSelector((state) => state?.details?.details || {});
  console.log("detailsToSend in instant pay ====>>>", detailsToSend);
  const userDetails = useSelector((state) => state?.user?.user || {});

  const [cardValidatorResp, setCardValidatorResp] = useState({});
  const [detailsError, setDetailsError] = useState("");
  const [ipAddress, setIpAddress] = useState("");
  const [creditCardError, setCreditCardError] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [creditLengthError, setCreditLengthError] = useState("");
  const [cardError, setCardError] = useState("");

  const creditCardRef = useRef(null);
  const mobileRef = useRef(null);
  const amountRef = useRef(null);

  const CC_REGEX = /^[0-9]{16}$/;
  const MOBILE_REGEX = /^[6-9][0-9]{9}$/;
  const AMOUNT_REGEX = /^[0-9]+$/;

  const amount = Number(detailsToSend?.actualAmount || 0);

  const isValidCC = CC_REGEX.test(detailsToSend?.creditCardNumber || "");
  const isValidMobile = MOBILE_REGEX.test(
    detailsToSend?.customerMobileNumber || "",
  );
  const isValidAmount =
    AMOUNT_REGEX.test(detailsToSend?.actualAmount || "") && amount > 0;
  const isValidLimitAmount = amount >= 1 && amount <= 200000;

  const isFormValid =
    isValidCC && isValidMobile && isValidAmount && isValidLimitAmount;

  const handleContinue = async () => {
    if (doubleTap.current) return;
    doubleTap.current = true;

    if (!isFormValid) {
      setDetailsError(
        `Check the Details once or chek limit, it should be 1 to 2,00,000`,
      );
      return;
    }
    console.log("cardValidatorResp ====>>", cardValidatorResp);
    try {
      const amount = Number(detailsToSend?.actualAmount || 0);
      const data = {
        body: detailsToSend,
        binResponse: cardValidatorResp?.response,
      };

      const resp = await Call_Api(
        path.VALIDATE_CARD_INSTANTPAY,
        "POST",
        data,
        token,
      );

      console.log("resp in instant pay validate ===>>>", resp);
      const dtaBack = resp?.response?.message;
      if (!resp?.response?.success) {
        if (dtaBack?.toLowerCase() == "invalid request payload") {
          setCreditCardError("Invalid creditcard details");
          return;
        } else {
          setCreditCardError(resp?.response?.message);
          return;
        }
      }

      if (resp?.success) {
        const chargeData = await fetchWalletCharges(amount);
        if (!chargeData) return;

        console.log(
          "chargeData cardValidatorResp in ccInstantPay====>>",
          chargeData,
          cardValidatorResp,
        );
        dispatch(
          setDetailsToSend({
            ...detailsToSend,
            payOutFee: chargeData.payOutFee,
            payOutPercentage: chargeData.payOutPercentage,
            payOutChargedAmount: chargeData.fee,
            chargedAmount: chargeData.fee,
            totalAmount: chargeData.totalAmount,
            amount: chargeData.totalAmount,
            billType: "billPayRequest",
            mobileNumber: userDetails?.mobileNumber,
            bbpsGateWay: detailsToSend?.payOption,
            walletAmount: Number(userDetails?.walletBalance),
            walletPayOutPercentage: chargeData.payOutPercentage,
            walletPayOutFee: chargeData.payOutFee,
            ip: ipAddress,
          }),
        );

        navigate("/PaymentMethod", {
          state: {
            Selectedoperator: detailsToSend?.operator,
            walletballance: Number(userDetails?.walletBalance),
            ntarTransactionId: detailsToSend?.ntarTransactionId,
          },
        });
      }
    } catch (err) {
      console.error("Instant Pay error", err);
    } finally {
      doubleTap.current = false;
    }
  };

  const fetchWalletCharges = async (amount) => {
    const details = {
      paymentMethod: "Credit Card",
      paymentMode: "Credit Card",
      paymentType: "Credit Card",
      serviceName: "PayOut",
    };

    const res = await Call_Api(
      path.BBPS_GET_WALLET_PAYOUT_CHARGES,
      "POST",
      details,
      token,
    );

    if (res?.response?.length > 0) {
      const { payOutFee, payOutPercentage } = res.response[0];

      const fee = payOutFee
        ? Number(payOutFee)
        : (Number(payOutPercentage || 0) / 100) * amount;

      return {
        payOutFee,
        payOutPercentage,
        fee,
        totalAmount: amount + fee,
      };
    }
    return null;
  };

  useEffect(() => {
    sessionStorage.setItem("CC_INSTANT_PAY_ACTIVE", "true");
  }, []);

  useEffect(() => {
    const card = detailsToSend?.creditCardNumber;
    if (!card || card.length !== 16) return;

    const timer = setTimeout(async () => {
      try {
        const response = await Call_Api(
          path.VALIDATE_CREDIT_CARDNUMBER,
          "POST",
          {
            ...detailsToSend,
            card_number: card,
            skipValidation: true,
          },
          token,
          dispatch,
        );
        console.log("resp in validate card in instant pay", response);
        if (response?.response?.is_valid && response?.success) {
          setCardValidatorResp(response);
        } else {
          setCardValidatorResp({});
          setCardError(response?.message || response?.response?.message);
        }
      } catch (e) {
        console.error("Card validation failed", e);
      }
    }, 200);

    return () => clearTimeout(timer);
  }, [detailsToSend?.creditCardNumber]);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue =
        "If you refresh the page, you will have to start from the beginning.";
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    const wasActive = sessionStorage.getItem("CC_INSTANT_PAY_ACTIVE");

    if (
      wasActive &&
      !detailsToSend?.serviceName &&
      !detailsToSend?.creditCardNumber
    ) {
      sessionStorage.removeItem("CC_INSTANT_PAY_ACTIVE");

      navigate("/bbps/Credit Card Instant", {
        replace: true,
        state: {
          record: "Credit Card",
        },
      });
    }
  }, []);

  useEffect(() => {
    fetch("https://api.ipify.org?format=json")
      .then((res) => res.json())
      .then((data) => setIpAddress(data.ip));

    if (!detailsToSend?.creditCardNumber) {
      dispatch(
        setDetailsToSend({
          ...detailsToSend,
          creditCardNumber: "",
          customerMobileNumber: "",
        }),
      );
    }
  }, []);

  return (
    // <div className="cc-wrapper">
    //   <div className="cc-header">
    //     <KeyboardBackspaceIcon
    //       className="back-icon"
    //       fontSize="large"
    //       onClick={() => {
    //         dispatch(
    //           setDetailsToSend({
    //             subService: "",
    //           }),
    //         );
    //         if (detailsToSend?.origin?.toLowerCase() == "existing") {
    //           navigate("/CreditCardInstantPay");
    //         } else {
    //           navigate("/bbps/Credit Card Instant", {
    //             state: { record: "Credit Card" },
    //           });
    //         }
    //       }}
    //     />
    //   </div>
    //   <div className="cc-card">
    //     <h3>{detailsToSend.serviceName}</h3>

    //     <div className="provider">
    //       <img src={detailsToSend?.billerLogo} alt="logo" className="icon_instant_s" />
    //       <strong>{detailsToSend?.billerName}</strong>
    //     </div>

    //     <div className="form_ss">
    //       <div className="label_input_s">
    //       <label>Credit Card Number *</label>
    //       <input
    //         ref={creditCardRef}
    //         maxLength="16"
    //         placeholder="Enter Credit Card Number"
    //         value={detailsToSend?.creditCardNumber || ""}
    //         onChange={(e) => {
    //           const value = e.target.value.replace(/\D/g, "");
    //           setCardError("");
    //           setCreditCardError("");
    //           dispatch(
    //             setDetailsToSend({
    //               ...detailsToSend,
    //               creditCardNumber: value,
    //             }),
    //           );

    //           // error handling
    //           if (value.length > 0 && value.length < 16) {
    //             setCreditLengthError("Credit Card number must be 16 digits");
    //           } else {
    //             setCreditLengthError("");
    //           }

    //           // auto move to mobile
    //           if (value.length === 16) {
    //             mobileRef.current?.focus();
    //           }
    //         }}
    //       />
    //       </div>
    //       <p style={{ color: "red" }}>{creditLengthError}</p>

    //       <div className="label_input_s">
    //       <label>
    //         Registered Mobile Number *
    //       </label>
    //       <input
    //         ref={mobileRef}
    //         maxLength="10"
    //         placeholder="Enter Mobile Number"
    //         value={detailsToSend?.customerMobileNumber || ""}
    //         onChange={(e) => {
    //           const value = e.target.value.replace(/\D/g, "");
    //           setCreditCardError("");
    //           dispatch(
    //             setDetailsToSend({
    //               ...detailsToSend,
    //               customerMobileNumber: value,
    //             }),
    //           );

    //           // error handling
    //           if (value.length > 0 && value.length < 10) {
    //             setMobileError("Mobile number must be 10 digits");
    //           } else {
    //             setMobileError("");
    //           }

    //           // auto move to amount
    //           if (value.length === 10) {
    //             amountRef.current?.focus();
    //           }
    //         }}
    //       />
    //       </div>
    //       <p style={{ color: "red" }}>{mobileError}</p>

    //       <div className="label_input_s">
    //       <label>Amount *</label>
    //       <input
    //         value={detailsToSend?.actualAmount || ""}
    //         placeholder="Enter Amount"
    //         ref={amountRef}
    //         onChange={(e) => {
    //           const value = e.target.value.replace(/\D/g, "");

    //           dispatch(
    //             setDetailsToSend({
    //               ...detailsToSend,
    //               actualAmount: value,
    //             }),
    //           );
    //         }}
    //       />
    //       </div>
    //     </div>
    //     {Number(detailsToSend?.actualAmount) > 200000 ||
    //     Number(detailsToSend?.actualAmount) < 1 ? (
    //       <p style={{ color: "red" }}>You Can Enter From 1 to 2,00,000 only</p>
    //     ) : (
    //       ""
    //     )}

    //     <button
    //       className={`btnPay ${isFormValid ? "active" : "disabled"}`}
    //       disabled={
    //         !isFormValid || Boolean(creditCardError) || Boolean(detailsError)
    //       }
    //       onClick={handleContinue}
    //     >
    //       Continue
    //     </button>
    //     <p style={{ color: "red" }}>{detailsError}</p>
    //     <p style={{ color: "red" }}>{creditCardError}</p>
    //     <p style={{ color: "red" }}>{cardError}</p>
    //   </div>
    // </div>
    <div className="InstantBbps-container">
      {/* Back Icon */}
      <div className="back-icon-createlink_s_i">
        <KeyboardBackspaceIcon
          fontSize="large"
          onClick={() => {
            dispatch(setDetailsToSend({ subService: "" }));

            if (detailsToSend?.origin?.toLowerCase() === "existing") {
              navigate("/CreditCardInstantPay");
            } else {
              navigate("/bbps/Credit Card Instant", {
                state: { record: "Credit Card" },
              });
            }
          }}
        />
      </div>

      {/* Title */}
      <div className="title_s">Enter Payment Details</div>

      {/* Biller Info */}
      <div className="titleImage_s_i">
        <img
          src={detailsToSend?.billerLogo}
          alt="logo"
          className="bbpsImage_s"
        />
        <p className="Note_s_wA">{detailsToSend?.billerName}</p>
      </div>

      {/* Card */}
      <div className="card_s_i">
        {/* Credit Card Number */}
        <div className="form-group my-3">
          <label>
            Credit Card Number
            <span className="text-danger ms-1">*</span>
          </label>

          <input
            ref={creditCardRef}
            type="text"
            maxLength="16"
            className={`form-control ${creditLengthError ? "is-invalid" : ""}`}
            placeholder="Enter Credit Card Number"
            value={detailsToSend?.creditCardNumber || ""}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "");
              setCardError("");
              setCreditCardError("");

              dispatch(
                setDetailsToSend({
                  ...detailsToSend,
                  creditCardNumber: value,
                }),
              );

              if (value.length > 0 && value.length < 16) {
                setCreditLengthError("Credit Card number must be 16 digits");
              } else {
                setCreditLengthError("");
              }

              if (value.length === 16) {
                mobileRef.current?.focus();
              }
            }}
          />

          {creditLengthError && (
            <small className="text-danger">{creditLengthError}</small>
          )}
        </div>

        {/* Mobile Number */}
        <div className="form-group my-3">
          <label>
            Registered Mobile Number
            <span className="text-danger ms-1">*</span>
          </label>

          <input
            ref={mobileRef}
            type="text"
            maxLength="10"
            className={`form-control ${mobileError ? "is-invalid" : ""}`}
            placeholder="Enter Mobile Number"
            value={detailsToSend?.customerMobileNumber || ""}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "");
              setCreditCardError("");

              dispatch(
                setDetailsToSend({
                  ...detailsToSend,
                  customerMobileNumber: value,
                }),
              );

              if (value.length > 0 && value.length < 10) {
                setMobileError("Mobile number must be 10 digits");
              } else {
                setMobileError("");
              }

              if (value.length === 10) {
                amountRef.current?.focus();
              }
            }}
          />

          {mobileError && <small className="text-danger">{mobileError}</small>}
        </div>

        {/* Amount */}
        <div className="form-group my-3">
          <label>
            Amount
            <span className="text-danger ms-1">*</span>
          </label>

          <input
            ref={amountRef}
            type="text"
            className="form-control"
            placeholder="Enter Amount"
            value={detailsToSend?.actualAmount || ""}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "");
              dispatch(
                setDetailsToSend({
                  ...detailsToSend,
                  actualAmount: value,
                }),
              );
            }}
          />
        </div>

        {/* Amount Error */}
        {(Number(detailsToSend?.actualAmount) > 200000 ||
          Number(detailsToSend?.actualAmount) < 1) && (
          <p className="error_s_i">
            You can enter amount from 1 to 2,00,000 only
          </p>
        )}

        {/* Global Errors */}
        {detailsError && <p className="error_s_i">{detailsError}</p>}
        {creditCardError && <p className="error_s_i">{creditCardError}</p>}
        {cardError && <p className="error_s_i">{cardError}</p>}

        <p className="Note_s_wA">
          Note: Don&apos;t refresh till the process is completed!
        </p>

        {/* Continue Button */}
        <button
          className="btn_s_i"
          disabled={
            !isFormValid || Boolean(creditCardError) || Boolean(detailsError)
          }
          onClick={handleContinue}
        >
          Continue
        </button>
      </div>
    </div>
  );
};

export default CCInstantPay;
